import React from 'react';
import Chip from '@mui/material/Chip';
import {
  NEW_PROJECT_COLOR,
  NEW_PROJECT_TEXT_COLOR,
  USEFUL_INFORMATION_COLOR,
  USEFUL_INFORMATION_TEXT_COLOR,
  GRAY_COLOR_LIGHT,
  TEXT_COLOR_PRIMARY
} from '../../../../constants/colors';

const typeSettings = {
  project: {
    label: "新着案件",
    backgroundColor: NEW_PROJECT_COLOR,
    textColor: NEW_PROJECT_TEXT_COLOR,
  },
  useful_info: {
    label: "お役立ち情報",
    backgroundColor: USEFUL_INFORMATION_COLOR,
    textColor: USEFUL_INFORMATION_TEXT_COLOR,
  },
}

export default function TypeLabel({ type }) {
  const chipSetting = typeSettings[type] || {
    label: "その他",
    backgroundColor: GRAY_COLOR_LIGHT,
    textColor: TEXT_COLOR_PRIMARY,
  };

  return (
    <Chip
      label={chipSetting.label}
      sx={{
        backgroundColor: chipSetting.backgroundColor,
        color: chipSetting.textColor,
      }}
    />
  );
}
